import { NIGHTLIFE_EVENTBRITE_CATEGORY } from '@eventbrite/categories';
import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { countryMapping } from '../../../../__fixtures__/countryNameCountryCode';
import { CategoryBrowseEvents } from '../../containers/CategoryBrowseEvents';
import { useLocation } from '../../hooks/queries/location';
import { CATEGORY_BROWSE_PLACEMENT } from '../../utils/analytics';

const ELIGIBLE_CATEGORIES = [
    'music',
    'holiday',
    'film-and-media',
    'food-and-drink',
    'comedy',
];

const queryOverload = (country: string) => {
    return {
        page_size: 25,
        start_hour_range: {
            end_hour: 24,
            start_hour: 20,
        },
        price_range: {
            minimum_price: 100, //100 in USD would represent 100 pennies, or $1 USD
            maximum_price: 3000,
            currency: countryMapping[country]?.currency ?? 'USD',
        },
    };
};

export const isAndroid = () => {
    return (
        typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent)
    );
};

export const NightlifeEvents = withRouter((props: any) => {
    const { category, subcategory } = props.match.params;
    const { data: locationData } = useLocation();

    //will be visible only on android and for eligible categories
    if (!isAndroid() || !ELIGIBLE_CATEGORIES.includes(subcategory || category))
        return null;

    return (
        <>
            {locationData?.country && (
                <CategoryBrowseEvents
                    queryOverload={queryOverload(locationData.country)}
                    title={gettext('After 8pm')}
                    bucketName={CATEGORY_BROWSE_PLACEMENT}
                    bucketKey={NIGHTLIFE_EVENTBRITE_CATEGORY}
                    bucketPosition="2"
                    lazyLoadCarouselElements
                    adSlots={[1, 4]}
                />
            )}
        </>
    );
});
